import { render, staticRenderFns } from "./gyjz.vue?vue&type=template&id=a972fefe&scoped=true"
import script from "./gyjz.vue?vue&type=script&lang=js"
export * from "./gyjz.vue?vue&type=script&lang=js"
import style0 from "./gyjz.vue?vue&type=style&index=0&id=a972fefe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a972fefe",
  null
  
)

export default component.exports